import { config, zSpaceConfig } from '../config';
import { BoxGeometry, Mesh, MeshBasicMaterial, Object3D, Vector3 } from 'three';
import AlcoModule from './PetriModules/AlcoModule';
import SanitizerModule from './PetriModules/SanitizerModule';
import BurnModule from './PetriModules/BurnModule';
import DishOpeningModule from './PetriModules/DishOpeningModule';
import { ParentEvent, ResourcesManager, ScenarioProcessor, Viewer, ViewerModule } from '@verybigthings/vbt-webvr-framework';
import WaxModule from './PetriModules/WaxModule';
import IncubateModule from './PetriModules/IncubateModule';
import ZoomModule from './PetriModules/ZoomModule';
import TasksProgress from '../components/TasksProgress';
import TaskScreen from '../components/TaskScreen';
import WelcomeScreen from '../components/WelcomeScreen';
import DrawModule from './PetriModules/DrawModule';
import LobbyScreen from '../components/LobbyScreen';
import { MaterialImprovement } from '../utils/MaterialImprovement';
import { SprayModule } from './PetriModules/SprayModule';
import { PickingControllerEvents } from "@verybigthings/vbt-webvr-framework/build/main/ts/controls/PickingController";
export default class PetriLevel extends ViewerModule {
    constructor(levelNumber, title, lobby) {
        super();
        this.lobby = lobby;
        this.__inited = false;
        this.loopBurned = false;
        this.cameraPositionVR = new Vector3(-34.775, -15.5976, 10.794);
        this.wrapScreenPosition = new Vector3(-3.52, 1.54, -5.15);
        this.instruments = {
            alco: null,
            rag: null,
            burner: null,
            loop: null,
            dish1: null,
            dish2: null,
            incubator: null,
            wax: null
        };
        this.levelFinished = false;
        this._interaction = false;
        this.viewerConf = config;
        this.pointerController = Viewer.pointerController;
        this.cameraPosition = new Vector3(-34.775, -13.5976, 10.794);
        this.cameraTargetNormal = new Vector3(-34.784, -13.6, 10.79);
        this.uiObject.name = 'PETRI LEVEL';
        this.table = ResourcesManager.getModel('petri_table').clone();
        this.table.name = 'TABLE';
        const groupAllPH = new Object3D();
        groupAllPH.name = 'ph_group';
        this.table.add(groupAllPH);
        this.zSpacePositions = zSpaceConfig.petri;
        this.table.position.set(0, -7, 0);
        this.addObject(this.table);
        this.initInstruments();
        this.addUI();
        this.addLobbyUI(levelNumber, title);
        this.init();
        this.initScenario();
    }
    get interaction() {
        return this._interaction;
    }
    set interaction(value) {
        this._interaction = value;
    }
    init() {
        this.addObject(window['spray'] = this.sprayModule = new SprayModule());
        this.sprayModule.uiObject.visible = false;
        this.sprayModule.init();
        this.alcoModule = new AlcoModule(this.instruments, this.instrumentsPositions, this.table, this.pointerController, this, this.sprayModule);
        this.sanitizer = new SanitizerModule(this.pointerController, this, this.sprayModule);
        this.dishOpening = new DishOpeningModule(this.instruments, this.pointerController, this);
        this.burnModule = new BurnModule(this.instruments, this.table, this.pointerController, this, this.uiContainer);
        this.addObject(this.burnModule);
        this.drawModule = new DrawModule(this);
        this.uiContainer.add(this.drawModule.uiObject);
        this.waxModule = new WaxModule(this.instruments, this.instrumentsPositions, this.table, this.pointerController, this, this.uiContainer);
        this.incubateModule = new IncubateModule(this.instruments, this.instrumentsPositions, this.table, this.pointerController, this);
        this.addObject(this.incubateModule);
        this.zoomModule = new ZoomModule(this.instruments, this);
    }
    initInstruments() {
        this.instrumentsPositions = {
            alco: new Vector3(-2.28, 3.84, 2.65),
            rag: new Vector3(-1.35, 3.12, 2.56),
            burner: new Vector3(-.05, 4.77, .33),
            loop: new Vector3(.3, 3.09, 2.39),
            dish1: new Vector3(2.58, 3.2, 2.68),
            dish2: new Vector3(1.44, 3.2, 2.68),
            incubator: new Vector3(3.24, 4.04, 0.06),
            wax: new Vector3(3.68, 3.11, 2.79),
        };
        let incubator = ResourcesManager.getModel('petri_incubator').clone();
        let door = ResourcesManager.getModel('petri_incubator_door').clone();
        door.name = 'door';
        door.position.set(0.62, 0.216, 0);
        door.rotation.set(0, Math.PI * 2 / 3, 0);
        incubator.add(door);
        this.instruments.alco = ResourcesManager.getModel('petri_spray').clone();
        this.instruments.rag = ResourcesManager.getModel('petri_rag').clone();
        this.instruments.burner = ResourcesManager.getModel('petri_burner').clone();
        this.instruments.loop = ResourcesManager.getModel('petri_loop').clone();
        this.instruments.dish1 = ResourcesManager.getModel('petri_blue_empty').clone();
        this.instruments.dish2 = ResourcesManager.getModel('petri_dish_empty').clone();
        this.instruments.incubator = incubator;
        this.instruments.wax = ResourcesManager.getModel('petri_wax_tape').clone();
        this.instruments.loop.add(new Mesh(new BoxGeometry(0.5, 0.2, 1.8), new MeshBasicMaterial({ visible: false })));
        const cap1 = ResourcesManager.getModel('petri_dish_cap').clone();
        cap1.position.set(0, 0.18, -0.49);
        cap1.name = 'cap';
        this.instruments.dish1.children[0].userData.improveMaterialIgnore = true;
        this.instruments.dish1.add(cap1);
        const cap2 = ResourcesManager.getModel('petri_dish_cap').clone();
        cap2.position.set(0, 0.18, -0.49);
        cap2.name = 'cap';
        this.instruments.dish2.children[0].userData.improveMaterialIgnore = true;
        this.instruments.dish2.add(cap2);
        this.instruments.rag.userData.improveMaterialIgnore = true;
        for (let instrumentsKey in this.instruments) {
            this.table.add(this.instruments[instrumentsKey]);
            this.instruments[instrumentsKey].position.copy(this.instrumentsPositions[instrumentsKey]);
        }
        this.instruments.dish1.traverse((el) => el.visible = false);
        this.instruments.dish2.visible = false;
        this.instruments.loop.visible = false;
        this.instruments.wax.visible = false;
        this.instruments.incubator.rotation.set(0, -0.43, 0);
    }
    addUI() {
        this.addObject(this.uiContainer = new Object3D());
        this.uiContainer.name = 'uiContainer';
        this.uiContainer.visible = false;
        // this.uiContainer.position.z = -5;
        this.addObject(this.uiContainerObjects = new Object3D());
        this.uiContainerObjects.name = 'uiContainerObjects';
        // this.uiContainerObjects.visible = false;
        this.tasksProgress = new TasksProgress();
        this.tasksProgress.uiObject.position.set(0, 3.3, -5);
        this.tasksProgress.uiObject.name = 'Task PROGRESS';
        this.uiContainer.add(this.tasksProgress.uiObject);
        this.taskScreen = new TaskScreen();
        this.taskScreen.uiObject.position.set(0, 0, -5);
        this.taskScreen.uiObject.name = 'Task SCREEN';
        this.uiContainer.add(this.taskScreen.uiObject);
        this.welcomeScreen = new WelcomeScreen();
        this.welcomeScreen.uiObject.position.set(0, .5, 1);
        this.welcomeScreen.uiObject.name = 'ERROR_POP_UP';
        this.welcomeScreen.uiObject.visible = false;
        this.uiContainer.add(this.welcomeScreen.uiObject);
        this.welcomeScreen.on('ok', () => {
            // @ts-ignore
            if (!this.welcomeScreen.secondButton.uiObject.parent)
                this.levelFinished = true;
            if (this.levelFinished) {
                if (this.taskScreen && this.tasksProgress) {
                    this.removeObject(this.taskScreen);
                    this.removeObject(this.tasksProgress);
                }
                this.title.setProgress('10/10');
            }
            this.fire('exit', new ParentEvent('exit'));
        });
        this.welcomeScreen.on('secondButtonClick', () => {
            this.welcomeScreen.uiObject.visible = false;
            this.restart();
        });
    }
    addLobbyUI(levelNumber, title) {
        let lobbyUI = new Object3D();
        lobbyUI.name = 'LOBBY UI';
        this.addObject(lobbyUI);
        this.title = new LobbyScreen();
        this.title.init('Level ' + levelNumber, title, '0/10');
        lobbyUI.add(this.title.uiObject);
        this.title.uiObject.position.y = 10;
        this.title.on('start', () => {
            if (this.pointerController.currentPointerObject !== this.pointerController.defaultPointerObject)
                return;
            this.fire('start', new ParentEvent('start'));
        });
        this.on('started', () => this.interaction = true);
        this.title.on('tutorial', () => this.fire('tutorial'));
    }
    initScenario() {
        var _a, _b, _c;
        MaterialImprovement.upgradeMaterialsFromModel(this.table, this.uiObject.name);
        this.scenario = {
            name: 'scenarioName',
            modules: [
                { name: 'tasksProgress', instance: this.tasksProgress },
                { name: 'taskScreen', instance: this.taskScreen },
                { name: 'welcomeScreen', instance: this.welcomeScreen },
                { name: 'lobbyScreen', instance: this.title },
                { name: 'alcoModule', instance: this.alcoModule },
                { name: 'sanitizer', instance: this.sanitizer },
                { name: 'dishOpening', instance: this.dishOpening },
                { name: 'burnModule', instance: this.burnModule },
                { name: 'waxModule', instance: this.waxModule },
                { name: 'incubateModule', instance: this.incubateModule },
                { name: 'drawModule', instance: this.drawModule },
                { name: 'zoomModule', instance: this.zoomModule },
            ],
            steps: [
                {
                    onBefore: [
                        ['tasksProgress', 'init', 10, 0],
                        [
                            'taskScreen', 'init', 'Task 1',
                            'Clean your Workspace.',
                            'First, select the spray bottle with 10% Milton. \n ' +
                                'Then, drag the bottle over the dirty spots on the counter and click to spray. \n ' +
                                `Finally, select the green rag and ${((_a = Viewer.zSpace) === null || _a === void 0 ? void 0 : _a.enabled) ? 'without releasing' : ''} wipe it over the dirty spots until they are clean.`,
                            0.52
                        ]
                    ],
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.interaction = true;
                        this.alcoModule.once('alcoholed', resolve);
                    }),
                    onError: [['module1', 'setText', '1 step onError']],
                    onAfter: [['alcoModule', 'initRagWiping']]
                },
                {
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.alcoModule.once('wiped', resolve);
                    }),
                    onError: [['module1', 'setText', '2 step onError']],
                    onAfter: [
                        ['alcoModule', 'newSpray'],
                        ['lobbyScreen', 'setProgress', '1/10']
                    ]
                },
                {
                    onBefore: [
                        ['tasksProgress', 'init', 10, 1],
                        [
                            'taskScreen', 'init', 'Task 2',
                            'Clean your workspace a second time.',
                            'First, select the spray bottle with 70% Ethanol. \n ' +
                                'Then, drag the bottle over the dirty spots on the counter and click to spray. \n ' +
                                `Finally, select the green rag and ${((_b = Viewer.zSpace) === null || _b === void 0 ? void 0 : _b.enabled) ? 'without releasing' : ''} wipe it over the dirty spots until they are clean.`,
                            0.35
                        ]
                    ],
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.alcoModule.once('alcoholed2', resolve);
                    }),
                    onError: [['module1', 'setText', '1 step onError']],
                    onAfter: [['alcoModule', 'newRagWiping']]
                },
                {
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.alcoModule.once('wiped2', resolve);
                    }),
                    onError: [['module1', 'setText', '2 step onError']],
                    onAfter: [
                        ['lobbyScreen', 'setProgress', '2/10'],
                        ['sanitizer', 'init', this.instruments]
                    ]
                },
                {
                    onBefore: [
                        ['tasksProgress', 'init', 10, 2],
                        ['taskScreen', 'init', 'Task 3', 'Disinfect Hands.', 'Spray hands with 70% ethanol spray.', 1.4],
                    ],
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.sanitizer.once('hands_sanitised', () => {
                            let a = 0;
                            const insts = [this.instruments.loop, this.instruments.dish2, this.instruments.dish1, this.instruments.wax];
                            const interval = setInterval(() => {
                                if (insts[a]) {
                                    insts[a].visible = true;
                                    if (insts[a] === this.instruments.dish1) {
                                        this.instruments.dish1.traverse((el) => el.visible = true);
                                    }
                                    a++;
                                }
                                else {
                                    resolve();
                                    clearInterval(interval);
                                }
                            }, 350);
                        });
                    }),
                    onError: [['module1', 'setText', '2 step onError']],
                    onAfter: [['lobbyScreen', 'setProgress', '3/10']]
                },
                {
                    onBefore: [
                        ['dishOpening', 'init'],
                        ['tasksProgress', 'init', 10, 3],
                        ['taskScreen', 'init', 'Task 4', 'Open Petri Dishes.', 'Click on the lids of the petri dishes to open them.', 1.25]
                    ],
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.dishOpening.once('both_dish_opened', resolve);
                    }),
                    onError: [['module1', 'setText', '2 step onError']],
                    onAfter: [
                        ['burnModule', 'init'],
                        ['burnModule', 'initLanding'],
                        ['lobbyScreen', 'setProgress', '4/10']
                    ]
                },
                {
                    onBefore: [
                        ['tasksProgress', 'init', 10, 4],
                        [
                            'taskScreen', 'init', 'Task 5',
                            'Pick up a single colony.',
                            ((_c = Viewer.zSpace) === null || _c === void 0 ? void 0 : _c.enabled)
                                ? ('First, select the green loop sitting on the table. ' +
                                    'Next, drag it over the bunsen burner and hold it for 3 seconds to sterilize the loop. \n ' +
                                    'Finally touch the grey petri dish on the Left to pick up a colony. \n ' +
                                    'But don`t forget to sterilize the loop by the bunsen burner.')
                                : ('First, select the green loop sitting on the table. ' +
                                    'Next, click on the bunsen burner and drag clockwise around the circle to sterilize the loop. \n ' +
                                    'Finally touch the grey petri dish on the Left to pick up a colony. \n ' +
                                    'But don`t forget to sterilize the loop by clicking the bunsen burner.'),
                            0
                        ]
                    ],
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.burnModule.once('bacterias_landed', resolve);
                    }),
                    onError: [['module1', 'setText', '2 step onError']],
                    onAfter: [
                        ['burnModule', 'spreadBacteria'],
                        ['burnModule', 'disableBurning'],
                        ['lobbyScreen', 'setProgress', '5/10']
                    ]
                },
                {
                    onBefore: [
                        ['tasksProgress', 'init', 10, 5],
                        [
                            'taskScreen', 'init', 'Task 6',
                            'Spread the colony.',
                            'First, pick up the loop and touch the petri dish on the Right to get a closer view. \n ' +
                                'Then, drag the loop over the red guide to spread the colony on the petri dish.',
                            .8
                        ],
                        ['burnModule', 'showPetriGuide']
                    ],
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.burnModule.once('spread_started', resolve);
                    }),
                    onError: [['module1', 'setText', '2 step onError']],
                    onAfter: [
                        ['burnModule', 'startSpreading'],
                        ['drawModule', 'init', this.burnModule],
                        ['lobbyScreen', 'setProgress', '6/10']
                    ]
                },
                {
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.drawModule.once('spread_ended', resolve);
                    }),
                    onError: [['module1', 'setText', '2 step onError']],
                    onAfter: [
                        ['dishOpening', 'initClosing'],
                        ['burnModule', 'hideGuide']
                    ]
                },
                {
                    onBefore: [
                        ['tasksProgress', 'init', 10, 6],
                        [
                            'taskScreen', 'init', 'Task 7',
                            'Close Dishes.',
                            'First, put down the loop on the table. \n ' +
                                'Next, click on the lids to close the petri dishes.',
                            1.2
                        ]
                    ],
                    stepCondition: () => new Promise((resolve, reject) => {
                        var _a;
                        (_a = this.lobby.app.zSpacePickingController) === null || _a === void 0 ? void 0 : _a.off(PickingControllerEvents.MOVED, this.burnModule.loop.parent);
                        this.dishOpening.once('both_dish_closed', resolve);
                    }),
                    onError: [['module1', 'setText', '2 step onError']],
                    onAfter: [['waxModule', 'init']]
                },
                {
                    onBefore: [
                        [
                            'taskScreen', 'init', 'Task 8',
                            'Seal Blue Dish on the Right.',
                            'First, select the wax tape by clicking on it. \n ' +
                                'Next, click on the blue dish on the right. \n ' +
                                'Then, drag the wax tape clockwise around the circle to seal it. \n ' +
                                'Finally, put the wax tape back down on the table.',
                            0.45
                        ]
                    ],
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.waxModule.once('dish_waxed', resolve);
                    }),
                    onError: [['module1', 'setText', '2 step onError']],
                    onAfter: [
                        ['incubateModule', 'init'],
                        ['lobbyScreen', 'setProgress', '7/10']
                    ]
                },
                // @@@@@@@@@@@@
                {
                    onBefore: [
                        ['tasksProgress', 'init', 10, 7],
                        [
                            'taskScreen', 'init', 'Task 8',
                            'Incubate Dish.',
                            'First select the sealed dish on the right. \n ' +
                                'Next, drag the plate into the incubator.',
                            1.2
                        ]
                    ],
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.incubateModule.once('dish_planted', resolve);
                    }),
                    onError: [['module1', 'setText', '2 step onError']],
                    onAfter: [
                        ['incubateModule', 'startTimer'],
                        ['lobbyScreen', 'setProgress', '8/10']
                    ]
                },
                {
                    onBefore: [
                        ['tasksProgress', 'init', 10, 8],
                        ['taskScreen', 'init', 'Task 9', 'Wait for the colony to grow.', 'Leave the dish in the incubator overnight (about 8 to 9 hours).', 1.1]
                    ],
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.incubateModule.once('timer_end', resolve);
                    }),
                    onError: [['module1', 'setText', '2 step onError']],
                    onAfter: [
                        ['incubateModule', 'openIncubator'],
                        ['lobbyScreen', 'setProgress', '9/10']
                    ]
                },
                {
                    onBefore: [
                        ['tasksProgress', 'init', 10, 9],
                        [
                            'taskScreen', 'init', 'Task 10',
                            'Check Results.',
                            'First, remove the dish from the incubator and place it back on the table. \n ' +
                                'Then, click on the lid to open it up and see what happened to the colony overnight.',
                            0.8
                        ]
                    ],
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.incubateModule.once('dish_ready', resolve);
                    }),
                    onError: [['module1', 'setText', '2 step onError']],
                    onAfter: [
                        ['dishOpening', 'finalOpening'],
                        ['lobbyScreen', 'setProgress', '10/10']
                    ]
                },
                {
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.dishOpening.once('final_opened', resolve);
                    }),
                    onError: [['module1', 'setText', '2 step onError']],
                    onAfter: [['zoomModule', 'init']]
                },
                {
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.zoomModule.once('zoomed_green', () => {
                            this.levelFinished = true;
                            resolve();
                        });
                        this.zoomModule.once('zoomed_red', reject);
                    }),
                    onError: [
                        ['welcomeScreen', 'init', 'Experiment failed!', 'Loop was not sterilized before use.', 'Back to Lobby', 'Try Again!'],
                    ],
                    onAfter: [
                        ['welcomeScreen', 'init', 'Experiment finished!', 'You have successfully accomplished the experiment.', 'Back to Lobby'],
                        ['tasksProgress', 'init', 10, 10]
                    ]
                },
            ]
        };
        const scenarioProcessor = new ScenarioProcessor(this.scenario);
        scenarioProcessor.init();
        this.burnModule.once('loop_burned', () => this.loopBurned = true);
        this.zoomModule.once('level_ended', () => {
            // this.levelFinished = true;
            this.welcomeScreen.uiObject.visible = true;
        });
    }
    showInfo(isShow = true) {
        this.title.uiObject.visible = isShow;
        this.uiContainer.visible = !isShow;
        this.instruments.dish1.visible = !isShow;
    }
    hideAllInfo() {
        this.uiContainer.visible = this.title.uiObject.visible = false;
    }
    restart() {
        this.title.setProgress('0/10');
        this.pointerController.setObject(null);
        this.lobby.app.zSpacePickingController && this.lobby.app.zSpacePickingController.currentObject && this.lobby.app.zSpacePickingController.forceRelease();
        this.welcomeScreen.uiObject.visible = false;
        this.interaction = false;
        this.table.traverse(el => {
            if (this.lobby.app.zSpacePickingController)
                this.lobby.app.zSpacePickingController.off(null, el);
            this.actionController.off(null, el);
            if (el.parent && el.parent.name === 'ph_group')
                el.visible = false;
        });
        this.uiObject.traverse(el => {
            if (this.lobby.app.zSpacePickingController)
                this.lobby.app.zSpacePickingController.off(null, el);
        });
        for (let index in this.scenario.modules) {
            const module = this.scenario.modules[index];
            // @ts-ignore
            module.instance.beforeReset && module.instance.beforeReset();
        }
        for (let instrumentsKey in this.instruments) {
            // this.table.remove(this.instruments[instrumentsKey]);
            if (this.instruments[instrumentsKey].parent)
                this.instruments[instrumentsKey].parent.remove(this.instruments[instrumentsKey]);
            // console.log('this.instruments[instrumentsKey]', this.instruments[instrumentsKey]);
        }
        this.initInstruments();
        for (let instrumentsKey in this.instruments) {
            // this.instruments[instrumentsKey].visible = false;
        }
        for (let index in this.scenario.modules) {
            const module = this.scenario.modules[index];
            // @ts-ignore
            module.instance.reset && module.instance.reset();
        }
        this.initScenario();
    }
    update() {
    }
}
